import { type QConfigTableData } from '@exam-management/common/types';
import { Box, ExpandMoreRoundedIcon, Flex, IconButton, Rotate } from '@shared/components';

import { StructureNameInput } from '../structure-name-input';

export function renderChapterNameContent(
  data: QConfigTableData,
  isExpanded: boolean,
  onExpand?: (id: string) => void,
  disabledInput?: boolean,
) {
  const { id } = data;

  return (
    <Flex
      sx={{
        minHeight: '48px',
        position: 'relative',
        ':hover': { backgroundColor: (theme) => theme.palette.grey[50] },
      }}
    >
      <Box
        sx={(theme) => ({
          minWidth: theme.spacing(12),
          borderRight: '1px solid',
          borderColor: theme.palette.grey[300],
          backgroundColor: theme.palette.background.paper,
          position: 'absolute',
        })}
      />
      <Flex
        sx={(theme) => ({
          width: '100%',
          marginLeft: theme.spacing(12),
          alignItems: 'center',
          minHeight: '48px',
          borderTop: '1px solid',
          borderColor: theme.palette.grey[300],
          marginTop: '-1px',
        })}
      >
        <Flex sx={{ minWidth: '48px', alignItems: 'center', justifyContent: 'center' }}>
          <IconButton onClick={() => onExpand?.(id)}>
            <Rotate in={isExpanded}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          </IconButton>
        </Flex>
        <Flex
          sx={(theme) => ({
            flex: 1,
            p: theme.spacing(2, 1),
          })}
        >
          <StructureNameInput name={id} variant='body2Semibold' disabled={!disabledInput} />
        </Flex>
      </Flex>
    </Flex>
  );
}
